import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const BASE = process.env.REACT_APP_API_BASE ?? "/api";

export default function MagicPage() {
  const { token } = useParams();
  const [status, setStatus] = useState("consuming");

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      if (!token) {
        setStatus("missing");
        return;
      }
      try {
        const r = await fetch(`${BASE}/auth/consume/${encodeURIComponent(token)}`, {
          method: "GET",
          headers: { "Content-Type": "application/json" }
        });
        if (!r.ok) {
          setStatus(`error:${r.status}`);
          return;
        }
        const data = await r.json();
        const sessionToken = data && data.token ? data.token : token;
        localStorage.setItem("fw_token", sessionToken);
        if (cancelled) return;
        window.location.replace("/");
      } catch {
        if (!cancelled) setStatus("network-error");
      }
    };

    run();
    return () => { cancelled = true; };
  }, [token]);

  return (
    <div className="flex items-center justify-center min-h-screen text-neutral-700">
      {status === "consuming" && <span>Iniciando sesión…</span>}
      {status === "missing" && <span>Falta el token mágico.</span>}
      {status.startsWith("error") && <span>Login fallido ({status}).</span>}
      {status === "network-error" && <span>Error de red. Reintenta.</span>}
    </div>
  );
}
